import { render } from "./Dashboard-App.vue?vue&type=template&id=2c190841&scoped=true"
import script from "./Dashboard-App.vue?vue&type=script&lang=js"
export * from "./Dashboard-App.vue?vue&type=script&lang=js"

import "./Dashboard-App.vue?vue&type=style&index=0&id=2c190841&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c190841"]])

export default __exports__